import { Button, Card, CircularProgress, Grid } from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import { useCallback } from 'react';
import { Link, useHistory, useParams } from 'react-router-dom';
import Swal from 'sweetalert2';

import { BackdropLoading } from '../../../../components';
import { delDataAset, getDetailDataAset } from '../../../../redux/actions/AsetInvestasiActions';

const DetailData = () => {
    const { id } = useParams();
    const history = useHistory();
    const [loading, setLoading] = useState(false);
    const [showLoading, setShowLoading] = useState(false);
    const [params, setParams] = useState({
        thumbnail_landscape: "",
        thumbnail_portrait: "",
        name: "",
        province: "",
        city: "",
        type: "",
        product_code: ""
    });
    const showAlert = useCallback((text, success) => {
        Swal.fire({
            title: success ? 'Berhasil' : 'Oopss!',
            text: text,
            imageUrl: `/assets/images/icons/${
                success ? 'ic_success' : 'ic_error'
            }.svg`,
            imageWidth: 92,
            imageHeight: 92,
            confirmButtonText: 'Ok',
            confirmButtonColor: '#0083E2'
        }).then(res => {
            if(res.isConfirmed && success){
                history.goBack();
            }
        })
    }, [history]);
    const getData = useCallback(() => {
        setLoading(true);
        getDetailDataAset(id)
            .then((res) => {
                let data = res.data?.data;
                if (Object.keys(data).length > 0) {
                    setParams((pref) => ({
                        ...pref,
                        thumbnail_landscape: data?.thumbnail_landscape,
                        thumbnail_portrait: data?.thumbnail_portrait,
                        name: data?.name,
                        province: data?.province,
                        city: data?.city,
                        type: data?.type,
                        product_code: data?.product_code,
                    }));
                } else {
                    showAlert(
                        'Gagal mengambil detail data, coba beberapa saat lagi',
                        false
                    );
                }
                setLoading(false);
            })
            .catch((err) => {
                let error = err?.response?.data;
                showAlert(
                    Array.isArray(error?.data)
                        ? error?.data[0]
                        : 'Gagal mengambil detail data, coba beberapa saat lagi',
                    false
                );
                setLoading(false);
            });
    }, [id, showAlert]);
    useEffect(() => {
        setParams((pref) => ({
            ...pref,
            product_code: id
        }));
        getData();
    }, [getData, id]);

    const handleDelete = (code, nama) => {
        Swal.fire({
            title: 'Konfirmasi Hapus',
            text: 'Apakah anda yakin ingin menghapus data ' + nama,
            imageUrl: `/assets/images/icons/ic_delete.svg`,
            imageWidth: 92,
            imageHeight: 92,
            confirmButtonText: 'Hapus',
            confirmButtonColor: '#FD6D5D',
            showCancelButton: true,
            cancelButtonText: 'Batal',
            cancelButtonColor: '#0083E2',
            reverseButtons: true
        }).then((res) => {
            if (res.isConfirmed) {
                sendDelete(code);
            }
        });
    };

    const sendDelete = (code) => {
        setShowLoading(true);
        delDataAset(code)
            .then(() => {
                setShowLoading(false);
                showAlert('Berhasil menghapus data', true);
            })
            .catch((err) => {
                let error = err?.response?.data;
                setShowLoading(false);
                showAlert(
                    Array.isArray(error?.data)
                        ? error?.data[0]
                        : 'Gagal menghapus data, coba beberapa saat lagi',
                    false
                );
            });
    };
    return (
        <div className="m-sm-30">
            <Grid container spacing={4} justifyContent="center">
                <Grid item xs={11} md={9}>
                    <h3 className="fw-bold m-0">Detail Aset & Investasi Property</h3>
                </Grid>
                <Grid item xs={11} md={3}>
                    <Grid container spacing={2}>
                        <Grid item xs={6}>
                            <Link to={`/data-aset/edit/${id}`} className="btn btn-outline-primary flex items-center border-radius-0 w-full">
                                <img
                                    src="/assets/images/icons/ic_action_edit.svg"
                                    alt="icon edit"
                                />
                                <span className="pl-4">
                                    {' '}
                                    Edit{' '}
                                </span>
                            </Link>
                        </Grid>
                        <Grid item xs={6}>
                            <Button onClick={() => handleDelete(params.product_code, params.name)} variant="outlined" className='btn-outline-danger border-danger text-danger w-full'>
                                <img
                                    src="/assets/images/icons/ic_action_delete.svg"
                                    alt="icon delete"
                                />
                                <span className="pl-4">
                                    {' '}
                                    Delete{' '}
                                </span>
                            </Button>
                        </Grid>
                    </Grid>
                </Grid>
                <Grid item xs={11} md={12}>
                    <Card elevation={0} className="py-5 px-6 border-radius-0 ">
                        {loading ? (
                            <div className="text-center">
                                <CircularProgress color="primary" size={35} />
                            </div>
                        ) : (
                            <Grid container spacing={2}>
                                <Grid item xs={12} md={6}>
                                    <p className="mb-3 font-semibold text-16">Foto Landscape</p>
                                    <img src={params.thumbnail_landscape} alt={params.name} className="w-full" />
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    <p className="mb-3 font-semibold text-16">Foto Potrait</p>
                                    <img src={params.thumbnail_portrait} alt={params.name} className="max-w-450 mx-auto" />
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    <p className="mb-3 font-semibold text-16">Nama</p>
                                    <p>{params.name}</p>
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    <p className="mb-3 font-semibold text-16">Tipe</p>
                                    <p>{params.type}</p>
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    <p className="mb-3 font-semibold text-16">Provinsi</p>
                                    <p>{params.province}</p>
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    <p className="mb-3 font-semibold text-16">Kota</p>
                                    <p>{params.city}</p>
                                </Grid>
                            </Grid>
                        )}
                    </Card>
                </Grid>
            </Grid>
            <BackdropLoading open={showLoading} />
        </div>
    );
};

export default DetailData;
